import React, { useState, useEffect } from "react";
import { getCurrentUserProfile, editCurrentUserProfile } from "../utils";
import { strings } from "../utils/strings";
import { CompanyBanner, Profile } from "../assets/images";
import { Button, InputComp } from "../components";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services";
import { toast } from "react-toastify";
import { usePersistData } from "../store";

const UserProfile = () => {
  const [profile, setProfile] = useState({
    firstName: "",
    email: "",
    phoneNo: "",
    emergencyPhoneNo: "",
    employeeImageUrl: "",
  });
  const { setUser, user } = usePersistData();
  const [profileImageFile, setProfileImageFile] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const profileData = await getCurrentUserProfile();
          setProfile((prev) => ({
            ...prev,
            ...profileData,
          }));
        } catch (error) {
          console.error("Failed to fetch profile:", error);
        }
      } else {
        console.error("No user is logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  const handleChange = (key, value) => {
    setProfile((prev) => ({ ...prev, [key]: value }));
  };

  const handleImageChange = (e) => {
    setProfileImageFile(e.target.files[0]);
  };

  useEffect(() => {
    if (user) {
      console.log("User changed:", user);
      // Your logic here
    }
  }, [user]);

  const handleSave = async () => {
    setIsDisabled(true);
    try {
      const updatedProfile = await editCurrentUserProfile(
        profile,
        profileImageFile
      );

      setProfile((prev) => ({
        ...prev,
        employeeImageUrl: updatedProfile.employeeImageUrl,
      }));
      console.log("============", updatedProfile);
      toast.success("Profile updated successfully!");
      setUser(updatedProfile);
      window.location.reload();
      setIsDisabled(false);
    } catch (error) {
      setIsDisabled(false);
      toast.error(error.message || "Failed to save profile!");
    }
  };

  return (
    <div className="bg-color-2 py-8 px-6 h-full overflow-scroll">
      <div className="bg-white rounded-3xl p-6">
        <div className="flex justify-between">
          <p className="text-[32px] font-semibold">{strings["userProfile"]}</p>
        </div>
        <div className="relative pt-9">
          <img
            src={CompanyBanner}
            alt="Profile"
            className="w-full object-cover rounded-t-[16px]"
          />
          <div className="absolute left-[64px] bottom-[-80px]">
            <label htmlFor="profileImage" className="cursor-pointer">
              <img
                src={
                  profileImageFile
                    ? URL.createObjectURL(profileImageFile)
                    : profile.employeeImageUrl || Profile
                }
                alt="User"
                style={{ objectFit: "cover" }}
                className="w-[124px] h-[124px] rounded-full border-2 border-color-4 "
              />

              <input
                type="file"
                id="profileImage"
                key={"employeeImageUrl"}
                className="hidden"
                onChange={handleImageChange}
              />
            </label>
          </div>
        </div>
        <div className="ml-[165px] px-8">
          <p className="text-[30px] font-semibold">
            {profile.firstName || "Enter Name"}
          </p>
          <p className="text-base font-normal text-color-1">
            {profile.email || "Enter Email"}
          </p>
        </div>

        <div className="border border-border p-6 rounded-t-3xl mt-9">
          <div className="flex space-x-[16px] w-[100%]">
            <div className="w-[50%]">
              <InputComp
                label={strings["employeeName"]}
                placeHolder={strings["placeholderName"]}
                type="text"
                value={profile.firstName}
                handleChange={handleChange}
                inputKey="firstName"
                labelClasses="text-sm font-medium pb-[6px] text-color-1"
                classes="h-11 text-color-1 border-color-9 hover:border-black border-1 !w-[100%]"
              />
            </div>
            <div className="w-[50%]">
              <InputComp
                label={strings["employeeEmail"]}
                placeHolder={strings["placeholderEmail"]}
                type="text"
                value={profile.email}
                handleChange={handleChange}
                inputKey="email"
                labelClasses="text-sm font-medium pb-[6px] text-color-1"
                classes="h-11 text-color-1 border-color-9 hover:border-black border-1 !w-[100%]"
              />
            </div>
          </div>

          <div className="flex space-x-[16px] w-[100%]">
            <div className="w-[50%]">
              <InputComp
                label={strings["employeePhone"]}
                placeHolder={strings["placeholderPhone"]}
                type="text"
                value={profile.phoneNo}
                handleChange={handleChange}
                inputKey="phoneNo"
                labelClasses="text-sm font-medium pb-[6px] pt-6 text-color-1"
                classes="h-11 text-color-1 border-color-9 hover:border-black border-1 !w-[100%]"
              />
            </div>
            <div className="w-[50%]">
              <InputComp
                label={strings["employeeEmgPhone"]}
                placeHolder={strings["placeholderEmgPhone"]}
                type="text"
                value={profile.emergencyPhoneNo}
                handleChange={handleChange}
                inputKey="emergencyPhoneNo"
                labelClasses="text-sm font-medium pb-[6px] pt-6 text-color-1"
                classes="h-11 text-color-1 border-color-9 hover:border-black border-1 !w-[100%]"
              />
            </div>
          </div>
        </div>
        <div className="flex justify-end py-4 px-6 border border-border rounded-b-3xl gap-x-3">
          <Button variant="outlineArrow">{strings["cancelBtn"]}</Button>
          {/* <Button onClick={handleSave}>{strings["saveBtn"]}</Button> */}

          <Button
            classes={` justify-center ${
              isDisabled ? "opacity-50 cursor-not-allowed" : ""
            }`}
            onClick={isDisabled ? null : handleSave}
            disabled={isDisabled}
          >
            {strings["saveBtn"]}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
